//--------------- Landing Page -------------
import React from "react";
import Home from "./LandingPage/Home";
import "./LandingPage/Style.css"


const App = () => {
  return (
    <>
      <Home />
    </>
  )
}

export default App;
